export default __webpack_public_path__ + "static/media/wheat.8a318dc7.png";